import { ReceiptText, BellRing, History, Lock } from "lucide-react";
import { Reveal, RevealStagger, StaggerItem } from "@/components/Reveal";
import { FEATURES } from "@/data/site";

const ICONS = { receipt: ReceiptText, bell: BellRing, history: History, shield: Lock };

export default function Features() {
  return (
    <section id="features" className="relative scroll-mt-24 py-20 sm:py-28" data-testid="features">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="eyebrow">Why Warranty_Vault pro</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">
            Everything your receipts and warranties need
          </h2>
          <p className="mt-4 text-muted-foreground">
            Four pillars that keep every purchase documented, protected and ready the moment you need it.
          </p>
        </Reveal>

        <RevealStagger className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            const large = i === 0 || i === 3;
            return (
              <StaggerItem
                key={f.id}
                className={`group relative overflow-hidden rounded-2xl border border-border bg-card/50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-gold/40 ${
                  large ? "sm:col-span-2 lg:col-span-1" : ""
                }`}
              >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-sage/10 blur-2xl transition-opacity duration-300 group-hover:bg-sage/20" />
                <div className="relative grid h-12 w-12 place-items-center rounded-xl border border-gold/25 bg-gold/10 text-gold">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="relative mt-5 font-display text-lg font-semibold">{f.title}</h3>
                <p className="relative mt-2 text-sm leading-relaxed text-muted-foreground">{f.desc}</p>
              </StaggerItem>
            );
          })}
        </RevealStagger>
      </div>
    </section>
  );
}
